/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Compatibility_QInputs */

const en_gc_resources_faq_compatibility_q = /** @type {(inputs: Gc_Resources_Faq_Compatibility_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can GridCraft open Excel XLSX files?`)
};

const zh_gc_resources_faq_compatibility_q = /** @type {(inputs: Gc_Resources_Faq_Compatibility_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 能打开 Excel XLSX 文件吗？`)
};

/**
* | output |
* | --- |
* | "Can GridCraft open Excel XLSX files?" |
*
* @param {Gc_Resources_Faq_Compatibility_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_compatibility_q = /** @type {((inputs?: Gc_Resources_Faq_Compatibility_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Compatibility_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_compatibility_q(inputs)
	return zh_gc_resources_faq_compatibility_q(inputs)
});
export { gc_resources_faq_compatibility_q as "gc.resources.faq.compatibility.q" }